var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/IconTextExtension.ts
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import "@adornis/chemistry/elements/components/x-link.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseIconText } from "../../db/extensions/BaseIconText.js";
import "../components/x-buildify-color-picker.js";
import "../components/x-infobox.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var IconTextExtension = ({
  textExtension,
  iconExtension
}) => ({
  class: BaseIconText,
  toolbar: { icon: "text_rotate_vertical", text: { default: "Icon mit Text" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return xComponents(html`
      <x-icon-text-extension
        .textExtension=${textExtension}
        .iconExtension=${iconExtension}
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-icon-text-extension>
    `);
  },
  editor({ content, contentController, controllerBaseKeyPath, host }) {
    return html`
      <x-flex space="lg">
        <x-flex space="md">
          <x-text tone="subtle"> Icon: </x-text>
          ${iconExtension.editor?.({
      content: content.icon,
      contentController,
      controllerBaseKeyPath: [...controllerBaseKeyPath, "icon"],
      host
    })}
        </x-flex>
        <x-hr></x-hr>
        <x-flex space="md">
          <x-text tone="subtle"> Text: </x-text>
          ${textExtension.editor?.({
      content: content.iconText,
      contentController,
      controllerBaseKeyPath: [...controllerBaseKeyPath, "iconText"],
      host
    })}
        </x-flex>
      </x-flex>
    `;
  },
  group: "Schriften"
});
var XIconTextExtension = class extends ExtensionBoilerplate {
  _content(content) {
    return html`
      <x-flex horizontal crossaxis-center space="md">
        <!-- icon -->
        ${this.iconExtension?.render(content.icon, { isSubelement: true })}

        <!-- text -->
        ${this.textExtension?.render(content.iconText, { isSubelement: true })}
      </x-flex>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          width: "100%"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XIconTextExtension.prototype, "textExtension", 2);
__decorateClass([
  property({ attribute: false })
], XIconTextExtension.prototype, "iconExtension", 2);
XIconTextExtension = __decorateClass([
  customElement("x-icon-text-extension")
], XIconTextExtension);
export {
  IconTextExtension,
  XIconTextExtension
};
